import { getProductDelivery } from './get-product-delivery.js';

const defaultDeliveryResolver = (config, availability1 = [])=>availability1.map((availability)=>getProductDelivery(config, availability)
    )
;

export { defaultDeliveryResolver };
//# sourceMappingURL=default-delivery-resolver.js.map
